import axios, { getEnv } from './api';

// without informacaoADistancia
// nescessário para dash tipo instrumento e UFs
function filterRoutesNoInfo(fill) {
  let url = '';
  // DATA FINAL E INICIAL
  if (fill?.dataFinal && fill?.dataInicial && !fill?.cidades && !fill?.ufs) {
    url = `?dataInicio=${fill?.dataInicial}&dataFim=${fill?.dataFinal}`;
    return url;
  }
  // TODOS
  else if (fill?.ufs && fill?.cidades && fill?.dataFinal && fill?.dataInicial) {
    url = `?dataInicio=${fill?.dataInicial}&dataFim=${
      fill?.dataFinal
    }&uf=${fill?.ufs?.map((uf) => uf.id)}&cidade=${fill?.cidades?.map(
      (c) => c.id
    )}`;
    return url;
  }
  // DATA FINAL/INICIAL E UF
  else if (
    fill?.dataFinal &&
    fill?.dataInicial &&
    fill?.ufs &&
    !fill?.cidades
  ) {
    url = `?dataInicio=${fill?.dataInicial}&dataFim=${
      fill?.dataFinal
    }&uf=${fill?.ufs?.map((uf) => uf.id)}`;
    return url;
  }

  // UF E CIDADE
  else if (
    !fill?.dataFinal &&
    !fill?.dataInicial &&
    fill?.ufs &&
    fill?.cidades
  ) {
    url = `&uf=${fill?.ufs?.map((uf) => uf.id)}&cidade=${fill?.cidades?.map(
      (c) => c.id
    )}`;
    return url;
  }
  // CIDADE
  else if (
    !fill?.dataFinal &&
    !fill?.dataInicial &&
    !fill?.ufs &&
    fill?.cidades
  ) {
    url = `&cidade=${fill?.cidades?.map((c) => c.id)}`;
    return url;
  }
  // UF
  else if (
    !fill?.dataFinal &&
    !fill?.dataInicial &&
    !fill?.cidades &&
    fill?.ufs
  ) {
    url = `&uf=${fill?.ufs?.map((uf) => uf.id)}`;
    return url;
  }
  return url;
}

// with informacaoADistancia
function filterRoutes(fill) {
  let url = '';
  // DATA FINAL E INICIAL
  if (fill?.dataFinal && fill?.dataInicial && !fill?.cidades && !fill?.ufs) {
    url = `&dataInicio=${fill?.dataInicial}&dataFim=${fill?.dataFinal}`;
    return url;
  }
  // TODOS
  else if (fill?.ufs && fill?.cidades && fill?.dataFinal && fill?.dataInicial) {
    // console.log('city', fill.cidades);
    url = `&dataInicio=${fill?.dataInicial}&dataFim=${
      fill?.dataFinal
    }&uf=${fill?.ufs?.map((uf) => uf.id)}&cidade=${fill?.cidades?.map(
      (c) => c.id
    )}`;
    return url;
  }
  // DATA FINAL/INICIAL E UF
  else if (
    fill?.dataFinal &&
    fill?.dataInicial &&
    fill?.ufs &&
    !fill?.cidades
  ) {
    url = `&dataInicio=${fill?.dataInicial}&dataFim=${
      fill?.dataFinal
    }&uf=${fill?.ufs?.map((uf) => uf.id)}`;
    return url;
  }

  // UF E CIDADE
  else if (
    !fill?.dataFinal &&
    !fill?.dataInicial &&
    fill?.ufs &&
    fill?.cidades
  ) {
    url = `&uf=${fill?.ufs?.map((uf) => uf.id)}&cidade=${fill?.cidades?.map(
      (c) => c.id
    )}`;
    return url;
  }
  // CIDADE
  else if (
    !fill?.dataFinal &&
    !fill?.dataInicial &&
    !fill?.ufs &&
    fill?.cidades
  ) {
    url = `&cidade=${fill?.cidades?.map((c) => c.id)}`;
    return url;
  }
  // UF
  else if (
    !fill?.dataFinal &&
    !fill?.dataInicial &&
    !fill?.cidades &&
    fill?.ufs
  ) {
    url = `&uf=${fill?.ufs?.map((uf) => uf.id)}`;
    return url;
  }
  return url;
}

function filterRoutesTipos(fill) {
  let url = '';
  // DATA INICIAL
  if (fill?.dataFinal && !fill?.dataInicial) {
    url = `&dataFim=${fill?.dataFinal}`;
    return url;
  }
  // DATA FINAL E INICIAL
  else if (
    fill?.dataFinal &&
    fill?.dataInicial &&
    !fill?.cidades &&
    !fill?.ufs
  ) {
    url = `&dataFim=${fill?.dataFinal}&dataInicio=${fill?.dataInicial}`;
    return url;
  }
  // DATA FINAL/INICIAL E UF
  else if (fill?.dataFinal && fill?.dataInicial && fill?.ufs) {
    url = `&dataFim=${fill?.dataFinal}&dataInicio=${
      fill?.dataInicial
    }&uf=${fill?.ufs?.map((uf) => uf.id)}`;
    return url;
  }
  // TODOS
  else if (fill?.dataFinal && fill?.dataInicial && fill?.ufs && fill?.cidades) {
    url = `&cidade=${fill?.cidades?.map((c) => c.id)}&dataFim=${
      fill?.dataFinal
    }&dataInicio=${fill?.dataInicial}&uf=${fill?.ufs?.map((uf) => uf.id)}`;
    return url;
  }
  // UF E CIDADE
  else if (
    !fill?.dataFinal &&
    !fill?.dataInicial &&
    fill?.ufs &&
    fill?.cidades
  ) {
    url = `&cidade=${fill?.cidades?.map((c) => c.id)}&uf=${fill?.ufs?.map(
      (uf) => uf.id
    )}`;
    return url;
  }
  // CIDADE
  else if (
    !fill?.dataFinal &&
    !fill?.dataInicial &&
    !fill?.ufs &&
    fill?.cidades
  ) {
    url = `&cidade=${fill?.cidades?.map((c) => c.id)}`;
    return url;
  }
  // UF
  else if (
    !fill?.dataFinal &&
    !fill?.dataInicial &&
    !fill?.cidades &&
    fill?.ufs
  ) {
    url = `&uf=${fill?.ufs?.map((uf) => uf.id)}`;
    return url;
  }
  return url;
}

const dashboardServiceSas = {
  getRegistrosSAS: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/registros-sas?informacaoADistancia=false${filterRoutes(
          filters
        )}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },

  getAtendimentosHora: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/registros-sas/atendimentos-hora?informacaoADistancia=false${filterRoutes(
          filters
        )}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },

  getAtendimentosPorte: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/registros-sas/atendimentos-porte?informacaoADistancia=false${filterRoutes(
          filters
        )}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },

  getAtendimentosUf: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/registros-sas/atendimentos-uf?informacaoADistancia=false${filterRoutes(
          filters
        )}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getMediaAtendimentoUsuario: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/registros-sas/media-atendimento-usuario?informacaoADistancia=false${filterRoutes(
          filters
        )}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getMediaAtendimentoUsuarioPf: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/registros-sas/media-atendimento-usuario-pf?informacaoADistancia=false${filterRoutes(
          filters
        )}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getMediaAtendimentoUsuarioPj: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/registros-sas/media-atendimento-usuario-pj?informacaoADistancia=false${filterRoutes(
          filters
        )}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getMediaAtendimentosPorte: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/registros-sas/media-atendimentos-porte?informacaoADistancia=false${filterRoutes(
          filters
        )}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getPerfilUsuario: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/registros-sas/perfil-usuario?informacaoADistancia=false${filterRoutes(
          filters
        )}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getPorcentagemPerfilUsuarioUnico: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/registros-sas/porcentagem-perfil-usuario-unico?informacaoADistancia=false${filterRoutes(
          filters
        )}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getPorteTipoInstrumento: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/registros-sas/porte-tipo-instrumento${filterRoutesNoInfo(
          filters
        )}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },

  getTipoAtendimentoAPF: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/registros-sas/tipo-atendimento-apf?informacaoADistancia=false${filterRoutes(
          filters
        )}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getTipoAtendimentoAPO: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/registros-sas/tipo-atendimento-apo?informacaoADistancia=false${filterRoutes(
          filters
        )}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getUsuariosUnicos: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/registros-sas/usuarios-unicos?informacaoADistancia=false${filterRoutes(
          filters
        )}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },

  getTipoAtendimentoAPC: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/registros-sas/tipo-atendimento?tipoRealizacao=APC${filterRoutesTipos(
          filters
        )}&informacaoADistancia=false`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getTipoAtendimentoAPS: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/registros-sas/tipo-atendimento?tipoRealizacao=APS${filterRoutesTipos(
          filters
        )}&informacaoADistancia=true`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getTipoAtendimentoAPB: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/registros-sas/tipo-atendimento?tipoRealizacao=APB${filterRoutesTipos(
          filters
        )}&informacaoADistancia=false`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getTipoAtendimentoAPM: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/registros-sas/tipo-atendimento?tipoRealizacao=APM${filterRoutesTipos(
          filters
        )}&informacaoADistancia=false`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getTipoAtendimentoAPA: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/registros-sas/tipo-atendimento?tipoRealizacao=APA${filterRoutesTipos(
          filters
        )}&informacaoADistancia=true`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getTipoAtendimentoAPD: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/registros-sas/tipo-atendimento?tipoRealizacao=APD${filterRoutesTipos(
          filters
        )}&informacaoADistancia=false`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getTipoAtendimentoAPL: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/registros-sas/tipo-atendimento?tipoRealizacao=APL${filterRoutesTipos(
          filters
        )}&informacaoADistancia=false`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getTipoAtendimentoAPR: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/registros-sas/tipo-atendimento?tipoRealizacao=APR${filterRoutesTipos(
          filters
        )}&informacaoADistancia=false`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getTipoAtendimentoAPE: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/registros-sas/tipo-atendimento?tipoRealizacao=APE${filterRoutesTipos(
          filters
        )}&informacaoADistancia=false`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getTipoAtendimentoAPN: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/registros-sas/tipo-atendimento?tipoRealizacao=APN${filterRoutesTipos(
          filters
        )}&informacaoADistancia=false`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getStatusEnvioSAS: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/total-envio?informacaoADistancia=false${filterRoutes(
          filters
        )}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getPorcemEnvioSAS: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/porcentagem-envio?informacaoADistancia=false${filterRoutes(
          filters
        )}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getEnvioInstrumentoSAS: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/total-envio-tipo-instrumento${filterRoutesNoInfo(
          filters
        )}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getRecorrenciaPjSas: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/recorrencia-pj?informacaoADistancia=false${filterRoutes(
          filters
        )}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getRecorrenciaPjMeiSas: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/recorrencia-mei?informacaoADistancia=false${filterRoutes(
          filters
        )}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getRecorrenciaPjMeSas: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/recorrencia-me?informacaoADistancia=false${filterRoutes(
          filters
        )}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  getRecorrenciaPjEppSas: async (filters) => {
    try {
      const res = await axios.get(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/sas/atendimentos/dashboard/recorrencia-epp?informacaoADistancia=false${filterRoutes(
          filters
        )}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
};

export default dashboardServiceSas;
